import { render, staticRenderFns } from "./AutoHeading.vue?vue&type=template&id=9dac538e"
import script from "./AutoHeading.vue?vue&type=script&lang=js"
export * from "./AutoHeading.vue?vue&type=script&lang=js"
import style0 from "./AutoHeading.vue?vue&type=style&index=0&id=9dac538e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports